/* unplugin-vue-components disabled */import { render } from "./kpi.vue?vue&type=template&id=4faa7f38&scoped=true"
import script from "./kpi.vue?vue&type=script&lang=js"
export * from "./kpi.vue?vue&type=script&lang=js"

import "./kpi.vue?vue&type=style&index=0&id=4faa7f38&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faa7f38"],['__file',"src/components/widgets/kpi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4faa7f38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4faa7f38', __exports__)) {
    api.reload('4faa7f38', __exports__)
  }
  
  module.hot.accept("./kpi.vue?vue&type=template&id=4faa7f38&scoped=true", () => {
    api.rerender('4faa7f38', render)
  })

}


export default __exports__